import React, { ReactElement } from 'react';
import css from './IconButton.module.scss';
import classNames from 'classnames';
import { RoundedIconProps } from '../Icon/RoundedIcon/RoundedIcon.types';
import { SizedIconProps } from '../Icon/SizedIcon/SizedIcon.types';
import { GenericButtonProps } from '../ButtonBase/GenericButton/GenericButton.types';
import { GMGenericButton } from '../ButtonBase';

interface IIconButtonProps extends GenericButtonProps {
    sizedIcon: ReactElement<SizedIconProps> | ReactElement<RoundedIconProps>;
    label?: string;
    title?: string;
    ariaLabel: string;
    /** Displays a count icon */
    count?: number;
    slim?: boolean;
    headerIcon?: boolean;
}

export const IconButton: React.FC<IIconButtonProps> = React.memo((props) => (
    <GMGenericButton
        onClick={props.onClick}
        title={props.title}
        ariaLabel={props.ariaLabel}
        id={props.ariaLabel}
    >
        <div className={classNames(css.iconButton, {
            [css.slim]: props.slim,
            [css.headerIcon]: props.headerIcon,
        }, props.className)}
        >
            <div className={css.icon}>
                {props.count !== undefined && (
                    <div className={classNames(css.count, { [css.double]: props.count > 9 })}>
                        <span className={css.countValue}>{props.count}</span>
                    </div>
                )}
                {props.sizedIcon}
            </div>
            {props.label && (
                <div className={css.label}>
                    <span>{props.label}</span>
                </div>
            )}
        </div>
    </GMGenericButton>
));
